import { useState } from "react";
import { resetPassword } from "../../../api";
import { useUser } from "../../../hooks/useUser";
import { ResetPasswordController } from "../types";
import { toast } from "sonner";

export const useResetPasswordController = (): ResetPasswordController => {
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const user = useUser();

  const performReset = async () => {
    setLoading(true);
    user.setLoading(true);

    try {
      await resetPassword(email);
      toast.success("Success", { description: "Password reset email sent successfully" });
      setLoading(false);
      user.setLoading(false);
    } catch (error) {
      const errorMsg = "An error occurred while trying to reset password";
      setErrorMessage(errorMsg);
      toast.error("Error", { description: errorMsg });
      console.error("Password reset failed:", error);
      user.logUserOut();
      setLoading(false);
      user.setLoading(false);
    }
  };

  return {
    email,
    setEmail,
    loading,
    reset: performReset,
    errorMessage
  };
};
